// Imports
import React from 'react';
import { useLenis } from 'lenis/react';
//Contents
import Link from "../menu-link/LinkHelper";

export default function PageHero({navigate, lowPerfContent}) {

// Consts
    const lenis = useLenis()

// Smooth Scroll on arrow click
    const handleScroll = () => {
        if (lenis) {
            lenis.scrollTo(window.innerHeight * 1.09, {
                duration: 2,
                immediate: false,
                easing: (t) => 1 - Math.pow(1 - t, 3)
            })
        }
    }

    return (
        <div className='section section-page-hero-home'>
            {/*<div className="page-hero-home-arrow">*/}
            {/*    <svg id='nextSection' className="arrow" viewBox="0 0 120 108" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleScroll}>*/}
            {/*        <path d="M65.5211 87.4048V0H53.5211V86.837L7.8596 48.4675L0.139667 57.6546L55.999 104.593L59.859 107.837L63.7189 104.593L119.578 57.6546L111.858 48.4675L65.5211 87.4048Z"/>*/}
            {/*    </svg>*/}
            {/*</div>*/}
            <div className='page-hero-home-arrow'>

                {/*<Link navigate={navigate} href="/projects" className="button">*/}
                {/*    <span>Voir mes projets</span>*/}
                    <div className="arrow-container event-cursor">
                        <svg id='nextSection' onClick={handleScroll} className="arrow-down" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"/>
                        </svg>
                    </div>
                {/*</Link>*/}
            </div>
            <div id='contentLowPerf' className={`lowperf-content ${lowPerfContent}`}> {/*active*/}
                <div className='lowperf-content-inner'>
                    {/*<h1 className='lowperf-title'>MARTIN<br />CHEVROLLIER</h1>*/}
                    {/*<img className='lowperf-rock' src="/rock/Rock.png" alt="" />*/}
                </div>
            </div>
        </div>
    )
}